const monthCard = {
  // 月卡专区首页聚合
  monthCardHome: `/authApi/user/month-card/home`,
  // 档位与价格
  monthCardPlans: `/authApi/user/month-card/plans`,
  // 升级试算
  monthCardPreview: `/authApi/user/month-card/upgrade/preview`,
  // 创建新购订单
  monthCardPurchase: `/authApi/user/month-card/order/purchase`,
  // 创建重购订单
  monthCardRenew: `/authApi/user/month-card/order/renew`,
  // 创建升级订单
  monthCardUpgrade: `/authApi/user/month-card/order/upgrade`,
  // 创建支付单
  monthCardPay: `/authApi/user/month-card/create/trade/pay`,
  // 支付成功回调
  monthCardCallback: `/authApi/user/month-card/pay/callback`,
  // 获取月卡充值是否成功
  monthCardPayStatus: `/authApi/user/month-card/pay/status`,
  // 规则接口
  monthCardRules: `/authApi/user/month-card/rules`
};

export default monthCard;
